import { z } from 'zod'

// candle-interval presets: the value IS the candle granularity (minutes/hours/day/week/month),
// each with a sensible lookback window resolved on the backend.
export const candleIntervalSchema = z.enum(['5m', '15m', '30m', '1h', '4h', '1d', '1w', '1mo'])
export type CandleTimeframe = z.infer<typeof candleIntervalSchema>

// `from`/`to` are optional: omitted, the backend resolves the interval's own lookback window
// (the live-chart case). supplied, they request an explicit historical window — used by the
// day-trade performance page, where the range is picked by the user rather than by the preset.
// the window is still clamped to what T-Bank will serve for that granularity.
export const candleHistoryQuerySchema = z
  .object({
    interval: candleIntervalSchema,
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
  })
  .refine((d) => !(d.from && d.to) || d.from.getTime() <= d.to.getTime(), {
    message: '`from` must be <= `to`',
    path: ['from'],
  })
export type CandleHistoryQueryDto = z.infer<typeof candleHistoryQuerySchema>

export const candleSchema = z.object({
  time: z.string(), // ISO timestamp
  open: z.number(),
  high: z.number(),
  low: z.number(),
  close: z.number(),
  volume: z.number(),
})
export type CandleDto = z.infer<typeof candleSchema>
